import axios from 'axios'
import { Message } from 'element-ui'

// 创建axios实例
const service = axios.create({
  // baseURL: process.env.VUE_APP_BASE_API || '/api', // api的base_url
  baseURL: 'https://order.huitongxin.cn/api/', // api的base_url
  timeout: 30000 // 请求超时时间
})

// 请求拦截器
service.interceptors.request.use(
  config => {
    // 在发送请求之前做些什么
    // 可以在这里添加token
    const token = localStorage.getItem('token')
    if (token) {
      config.headers['Authorization'] = 'Bearer ' + token
    }
    
    // 可以在这里添加其他请求头
    config.headers['Content-Type'] = config.headers['Content-Type'] || 'application/json'
    
    console.log('请求拦截:', config)
    return config
  },
  error => {
    // 对请求错误做些什么
    console.error('请求错误:', error)
    return Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(
  response => {
    // 对响应数据做点什么
    const res = response.data
    
    // 根据自定义错误码判断请求是否成功
    if (res.code !== 200) {
      Message({
        message: res.msg || res.message || '请求失败',
        type: 'error',
        duration: 3 * 1000
      })
      
      // 特殊错误码处理
      if (res.code === 401) {
        // token过期或未登录
        Message({
          message: '登录已过期，请重新登录',
          type: 'error',
          duration: 2 * 1000
        })
        // 可以在这里跳转到登录页
        // router.push('/login')
        localStorage.removeItem('token')
      }
      
      return Promise.reject(new Error(res.msg || res.message || '请求失败'))
    } else {
      return res
    }
  },
  error => {
    // 对响应错误做点什么
    console.error('响应错误:', error)
    
    let message = '请求失败'
    if (error.response) {
      switch (error.response.status) {
        case 400:
          message = '请求错误'
          break
        case 401:
          message = '未授权，请登录'
          break
        case 403:
          message = '拒绝访问'
          break
        case 404:
          message = '请求地址不存在'
          break
        case 500:
          message = '服务器错误'
          break
        case 502:
          message = '网关错误'
          break
        case 503:
          message = '服务不可用'
          break
        case 504:
          message = '网关超时'
          break
        default:
          message = `连接错误${error.response.status}`
      }
    } else if (error.message) {
      if (error.message.includes('timeout')) {
        message = '请求超时'
      } else if (error.message.includes('Network')) {
        message = '网络连接失败'
      }
    }
    
    Message({
      message: message,
      type: 'error',
      duration: 3 * 1000
    })
    
    return Promise.reject(error)
  }
)

export default service

